import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MandateModel } from "./mandate.model";
import { MandateService } from "./mandate.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { CoreService } from '../../../core/header/core.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';import { MandateDialogDeleteComponent } from './mandate-dialog-delete.component';
import * as FileSaver from 'file-saver';
import { MandateConst } from '../const';

@Component({
    selector: 'convfact-mandate-list',
    templateUrl: './mandate-list.component.html',
    styleUrls: ['./mandate.component.css'],
    standalone: false
})
export class MandateListComponent implements OnInit {

    constructor(private router: Router, private mandateService: MandateService, public snackBar: MatSnackBar,
        private coreService: CoreService, public dialog: MatDialog) { }

    dataSource: MandateModel[] = [];
    empty: boolean = false;
    ready: boolean = false;
    headerTable: any[] = MandateConst.headerTable;

    displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10000;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }

    pdf(uid: string): void {
        this.mandateService.pdf(uid).then(response => {
            FileSaver.saveAs(response, "file.pdf");
        })
    }

    create(): void {
        this.router.navigate(['/account/mandate/create']);
    }

    edit(uid: string): void {
        this.router.navigate(['/account/mandate/edit' + `/${uid}`]);
    }

    delete(uid: string) {
        this.dialog.open(MandateDialogDeleteComponent, {
            data: { uid: uid }
        })
            .afterClosed().subscribe(result => {
                this.ngOnInit();
            });
    }

    ngOnInit() {
        this.coreService.setName("Mandatos");
        this.mandateService.getList().then(
            data => {
                this.dataSource = data;
                if ((typeof this.dataSource === 'undefined') || (this.dataSource.length == 0)) {
                    this.empty = true;
                } else {
                    this.empty = false;
                }
                this.ready = true;
            }
        );
    }

}
